import request from '@/utils/request'

export function getPolicyList(province_id) {
    return request({
        url: '/web/recommend/getPolicyList',
        method: 'post',
        data: {
            province_id: province_id
        }
    })
}

export function getNewsList(page, page_size) {
    return request({
        url: '/web/recommend/getNewsList',
        method: 'post',
        data: {
            page: page,
            size: page_size
        }
    })
}

export function getNewsDetail(id) {
    return request({
        url: '/web/recommend/getNewsDetail',
        method: 'post',
        data: {
            id: id
        }
    })
}

export function getPolicyNewsDetail(id) {
    return request({
        url: '/web/recommend/getPolicyDetail',
        method: 'post',
        data: {
            id: id
        }
    })
}